import React, { useContext } from 'react';
import Navbar from '../../components/navbar';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import PeopleIcon from '@material-ui/icons/People';
import ChatIcon from '@material-ui/icons/Chat';
import './style.scss';
import { Favorite } from '@material-ui/icons';
import { Context } from '../../store';

const Home = (props) => {
  const { state } = useContext(Context);
  return (
    <div className='home-wrapper'>
      <Navbar props={props} />
      <div className='logo-wrapper'>
        <Logo />
        <span>Hey i am Cai 😇</span>
      </div>
      <div className='home-btn'>
        <button
          onClick={() => {
            props.history.push('/register');
          }}>
          <div>
            <ChatIcon />
            <span>Start a conversation!</span>
          </div>
        </button>
        <button
          onClick={() => {
            props.history.push('/main');
          }}>
          <div>
            <PeopleIcon />
            <span>Back to chat friend!</span>
          </div>
        </button>
        <button
          onClick={() => {
            if (state.logged) {
              props.history.push('/global');
            } else {
              props.history.push('/global-free');
            }
          }}>
          <div>
            <PeopleIcon />
            <span>Chat to people, Global!</span>
          </div>
        </button>
      </div>
      <div className='home-footer'>
        Made by Bdbose
        <Favorite />
      </div>
    </div>
  );
};

export default Home;
